import { useEffect, useState } from 'react'

/**
 * Read the suite colour mode reactively. The AppearancePanel writes `data-mode`
 * ("light" | "dark", default dark) on <html>; this hook mirrors it into React so
 * canvas layers (the hero constellation, the numen warp) can re-theme the moment
 * the user flips the Aa control — no reload. Dark is the default/fallback.
 */
export function useColorMode(): 'light' | 'dark' {
  const read = (): 'light' | 'dark' =>
    typeof document !== 'undefined' &&
    document.documentElement.getAttribute('data-mode') === 'light'
      ? 'light'
      : 'dark'

  const [mode, setMode] = useState<'light' | 'dark'>(read)

  useEffect(() => {
    const root = document.documentElement
    const sync = () => setMode(root.getAttribute('data-mode') === 'light' ? 'light' : 'dark')
    sync() // catch any change between first render and effect
    const obs = new MutationObserver(sync)
    obs.observe(root, { attributes: true, attributeFilter: ['data-mode'] })
    return () => obs.disconnect()
  }, [])

  return mode
}
